<template>
    <div class="index">
        <el-container class="container_out">
            <el-aside   class="Navigation">
                <el-menu
                    @select="menuClick"
                    background-color="#ffffff"
                    text-color="#666"
                    :default-active="currentIndexLight"
                    class="el-menu-vertical-demo"
                    active-text-color="#5E81F4"
                    router
                    >
                <menuc  :menuData="menuDatas"></menuc>
          </el-menu>

            </el-aside>
  
            <el-container class="container_inner">
                <el-header class="container_inner_head">
                    <el-dropdown class="dropdown" @command="out">
                        <span class="el-dropdown-link">
                            <img class="hq" src="https://img1.baidu.com/it/u=4049022245,514596079&fm=253&fmt=auto&app=120&f=JPEG?w=889&h=500" alt="" srcset="">
                            <div class="user_name">{{ user.name }}</div>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command=1>修改密码</el-dropdown-item>
                            <el-dropdown-item command=2>退出登录</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </el-header>
                
                <el-main class="container_inner_content">
                    <router-view></router-view>
                    
                </el-main>
            </el-container>
        </el-container>
        <!-- 退出登录 -->
        <el-dialog
            title="信息提示"
            :visible.sync="dialogVisibleout"
            class="dialog_out"
            width="30%">
            <div class="dialog_pointer">
                <img style="width: 25px; height: 25px;border-radius: 50%;" src="https://img1.baidu.com/it/u=4049022245,514596079&fm=253&fmt=auto&app=120&f=JPEG?w=889&h=500" alt="" srcset="">
                
                <div class="dialog_pointer_right">
                    <div class="dialog_pointer_right_top">确定要退出登录吗？</div>
                    <div class="dialog_pointer_right_bottom">退出登录，会放弃当前所有操作~</div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisibleout = false">取 消</el-button>
                <el-button type="primary" @click="logout">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 修改密码 -->
        <el-dialog
            title="修改密码"
            :visible.sync="dialogVisiblecp"
            class="dialog_change"
            width="30%">
            <div class="dialog_change">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="原密码" prop="opw">
                        <el-input clearable show-password v-model="ruleForm.opw" placeholder="请输入原密码"></el-input>
                    </el-form-item>
                    <el-form-item label="新密码" prop="npw">
                        <el-input clearable show-password v-model="ruleForm.npw" placeholder="6~16位字符,区分大小写"></el-input>
                    </el-form-item>
                    <el-form-item label="确定密码" prop="cpw">
                        <el-input clearable show-password v-model="ruleForm.cpw" placeholder="在此输入新密码"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisiblecp = false">取 消</el-button>
                <el-button type="primary" @click="changepw('ruleForm')">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>


<script>
import menuc from './components/menu.vue'
  export default {
    components:{menuc},
    data() {
      return {
        menuDatas:[],
        currentIndexLight: "/home",
        dialogVisibleout:false,//退出登录弹框
        dialogVisiblecp:false,//修改密码弹框
        ruleForm: {
            opw: null,
            npw: null,
            cpw: null,
        },
        user:{},
        rules: {
            opw: [
                { required: true, message: '请输入原密码', trigger: 'blur' },
                { min: 1, max: 16, message: '长度在 1 到 16 个字符', trigger: 'blur' }],
          npw: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
            { min: 6, max: 16, message: '长度在 6 到 16 个字符', trigger: 'blur' }
          ],
          cpw: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
            { min: 6, max: 16, message: '长度在 6 到 16 个字符', trigger: 'blur' }
          ],
        
        }

      }
    },
    created(){
            let menu=sessionStorage.getItem('user_menu')
            this.menuDatas=JSON.parse( menu)
            // this.menuDatas.unshift({
            //     icon: null,
            //     id: 999,
            //     name: "首页",
            //     parentId: null,
            //     path: "/home",
            // })
            this.currentIndexLight=sessionStorage.getItem('activePath')
            this.user=JSON.parse( sessionStorage.getItem('user'))
        },
    methods:{
        //修改密码确定
        changepw(ruleForm){
            this.$refs[ruleForm].validate((valid) => {
            if (valid) {
                let validate=false
                let obj={
                    "confirmPassword":this.ruleForm.cpw,
                    "newPassword": this.ruleForm.npw,
	                "oldPassword": this.ruleForm.opw,
                }
                if(this.ruleForm.npw==this.ruleForm.cpw){
                    validate=true
                }else{
                    this.$message({
                        message: '新密码与再次输入密码不一致',
                        type: 'error'
                    });
                }
                if(validate==true){
                    this.$http.put('/userPassword/user',obj).then((res)=>{
                        console.log(res);
                        if(res.code==200){
                            this.$message({
                                message:'修改密码成功,请重新登录',
                                type:'success'
                            })
                            this.dialogVisiblecp=false;
                            sessionStorage.clear
                            this.$router.push('/login')
                        }else if(res.code==401){
                            this.$message({
                                message: res.message,
                                type: 'error'
                            });
                            this.$router.push('/login')
                        }else{
                            this.$message({
                                message: res.message,
                                type: 'error'
                            });
                        }
                    })
                }
            } else {
                return false;
            }
            });
        },
        //确定退出登录
        logout(){
            this.$http.post('/logout/user').then((res)=>{
                if(res.code==200){
                    this.$message({
                        message:'退出成功',
                        type:'success'
                    })
                    sessionStorage.clear()
                    this.$router.push('/login')
                }
            })
            

        },
        //退出登录按钮 1:修改密码 2:退出登录
        out(e){
            if(Number(e)==1){
                this.dialogVisiblecp=true;
            }else if(Number(e)==2){
                this.dialogVisibleout=true;
            }
        },
        //导航栏切换
        menuClick(e) {
              this.currentIndexLight = e;
              sessionStorage.setItem("activePath", e);
        },
    }
  };
</script>
<style lang="less" scoped>
    .index{
        width: 100%;
        height: 100%;
    }
    .container_out{
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        .container_inner{
            width: 100%;
            height:100%;
            .container_inner_head{
                width: 100%;
                height: 80px;
                display: flex;
                justify-content: right;
                align-items: center;
                .dropdown{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    .el-dropdown-link{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        .hq{
                            width:25px;
                            height: 25px;
                            border-radius: 50%;
                        }
                        .user_name{
                            box-sizing: border-box;
                            padding: 0px 10px;
                        }
                    }
                }
            }
            .container_inner_content{
                width: 100%;
                height: 100%;
                background: #f0f2f5;
            }
        }
        .Navigation{
            width: 200px;
            height: 100%;
        }
    }
    .dialog_out{
        .dialog_pointer{
            display: flex;
            align-items: center;
            .dialog_pointer_right{
                padding: 0px 10px;
                .dialog_pointer_right_top{

                }
            }
        }
    }
  .el-aside {
    color: #333;
  }
</style>